import { styled } from '@mui/material/styles';
import c from '@/components/Tables/constatnt';
import { MatchingColorsMap, TEXTRACT_MATCH_STATUSES } from '@/components/TwoWayMatch/matching';

const createClassName = (base, modifier = '') => (modifier ? `${base}-${modifier}` : base);

// Table-related classes
const TABLE = 'je-table';
const ROW = 'je-table-row';
const CELL = 'je-table-cell';
const COLGROUP = 'je-table-colgroup';

// Create the JE_TABLE_CLASSES object using the utility function
export const JE_TABLE_CLASSES = {
  TABLE,
  ROW,
  ROW_FIRST: createClassName(ROW, 'first'),
  ROW_LAST: createClassName(ROW, 'last'),
  ROW_LINE: createClassName(ROW, 'line'),
  ROW_LINE_TEXTRACT: createClassName(ROW, 'line-textract'),
  ROW_HOVERED: createClassName(ROW, 'hovered'),
  ROW_ACTIVE: createClassName(ROW, 'active'),
  CELL,
  CELL_FIRST: createClassName(CELL, 'first'),
  CELL_LAST: createClassName(CELL, 'last'),
  CELL_MANDATORY: createClassName(CELL, 'mandatory'),
  CELL_ACTIVE: createClassName(CELL, 'active'),
  CELL_MISMATCH: createClassName(CELL, 'mismatch'),
  CELL_REMOVE: createClassName(CELL, 'remove'),
  CELL_PINNED: createClassName(CELL, 'pinned'),
  COLGROUP_COL: createClassName(COLGROUP, 'col'),
  COLGROUP_COL_REMOVE: createClassName(COLGROUP, 'col-remove'),
};

export const JETableRoot = styled('table', {
  label: 'JETableRoot',
})(() => ({
  width: '100%',
  tableLayout: 'fixed',
  textAlign: 'left',
}));

export const JETableRow = styled('tr', {
  label: 'JETableRow',
})(({ theme }) => ({
  height: c.ROW_HEIGHT,
  lineHeight: `${c.ROW_HEIGHT}px`,
  background: theme.palette.common.white,

  [`&.${JE_TABLE_CLASSES.ROW_LINE_TEXTRACT}-${TEXTRACT_MATCH_STATUSES.DEFAULT}`]: {
    background: MatchingColorsMap[TEXTRACT_MATCH_STATUSES.DEFAULT].jeFill,
  },

  [`&.${JE_TABLE_CLASSES.ROW_LINE_TEXTRACT}-${TEXTRACT_MATCH_STATUSES.MATCH}`]: {
    background: MatchingColorsMap[TEXTRACT_MATCH_STATUSES.MATCH].fill,
  },

  [`&.${JE_TABLE_CLASSES.ROW_LINE_TEXTRACT}-${TEXTRACT_MATCH_STATUSES.PARTIAL_MATCH}`]: {
    background: MatchingColorsMap[TEXTRACT_MATCH_STATUSES.PARTIAL_MATCH].fill,
  },
}));

export const JETableRowCell = styled('td', {
  label: 'JETableColumn',
})(() => ({
  color: '#171A1C',
  border: '1px solid transparent',
  height: c.ROW_HEIGHT,
  position: 'relative',
  outline: 'none',

  '& *': {
    outline: 'none',
  },
}));

export const JETableRowCellRemove = styled('td', {
  label: 'JETableRowCellRemove',
})(({ theme }) => ({
  width: 30,
  lineHeight: 0,
  background: theme.palette.common.white,
  textAlign: 'center',
}));
